<template>
  <b-container fluid>
    <template>
      <b-overlay :show="loadingPdf">
          <b-row>
            <b-col lg="12" sm="12">
              <iq-card>
                <template>
                <b-overlay v-if="unitLoad">
                <!-- report head data -->
                <!-- PDF -->
                <b-col xs="12" sm="12" md="12" class="text-right mt-4" style="margin-left: -5px">
                    <b-button-group>
                        <b-button @click="pdfExport" variant="success"><i style="font-size: 18px; margin: 0; padding: 0;" class="ri-printer-fill"></i></b-button>
                    </b-button-group>
                </b-col>
                <b-row v-if="reportHeadData">
                    <b-col xs="12" sm="12" md="3" class="text-right mt-4">
                        <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                        <h3 class="text-bold">
                            {{ $t('production_store.govt_info') }}
                        </h3>
                        <h4 class="text-center text-dark">
                            {{ $t('social_service.dss') }}
                        </h4>
                        <!-- <span class="text-center text-dark">
                            {{ reportHeadData.heading }}
                        </span><br> -->
                        <span class="text-center text-dark">
                            {{ reportHeadData.address }}
                        </span><br>
                        <div class="titleDiv">
                            <span class="text-center text-dark reportTitle" style="font-weight:bold;">
                                    {{ $t('report.income_register') }}
                            </span><br>
                        </div>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" class="text-left mt-4">
                        <b-img :src="`${ reportHeadData.reportHeadColumn[1].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>

                </b-row>
                    <!-- report head data -->
                    <b-row class="details_report mt-4">
                      <b-col lg="12" sm="12">
                        <b-row class="mb-1">
                          <b-col lg="12" sm="12">
                            <div class="col-md-12">
                              <!-- <h5 class="font-weight-bold text-capitalize text-center p-2">{{ $t('report.income_register') }}</h5> -->
                              <!-- <b-row>
                                <b-col><p class="text-left">{{ $t('social_service.officer_name') }}: </p></b-col>
                              </b-row>
                              <b-row>
                                <b-col><p class="text-left">{{ $t('social_service.month') }}: </p></b-col>
                              </b-row> -->
    <!-- <h4 class="font-weight-bold  text-left">{{ $t('report_monthly.workplace_name') }}: {{this.search_report.workplace_name}}</h4>
    <h4 class="font-weight-bold  text-left">{{ $t('report_monthly.month_name') }}: {{this.search_report.month_name}}</h4> -->
    <h4 class="font-weight-bold  text-left">{{ $t('report_monthly.workplace_name') }}: {{this.search_report.workplace_name}}</h4>
    <h4 class="font-weight-bold  text-left">{{ $t('social_service.fisyear') }}: {{this.search_report.fisYear}}</h4>
    <h4 class="font-weight-bold  text-left">{{ $t('report_monthly.month_name') }}: {{this.search_report.month_name}}</h4>
                              <b-table-simple small bordered hover responsive>
                                <b-tr>
                                  <b-th colspan="2">{{ $t('report.sl_no_tarikh') }}</b-th>
                                  <b-th>{{ $t('report.donor_person_organization_name_address_mobile') }}</b-th>
                                  <b-th>{{ $t('report.receipt_book_no_page') }}</b-th>
                                  <b-th>{{ $t('report.cash_statement') }}</b-th>
                                  <b-th>{{ $t('report.cash_amount') }}</b-th>
                                  <b-th>{{ $t('report.bank_receipt_date_no') }}</b-th>
                                  <b-th>{{ $t('report.goods_description') }}</b-th>
                                  <b-th>{{ $t('report.goods_price') }}</b-th>
                                  <b-th>{{ $t('report.total_income_addition') }}</b-th>
                                  <b-th>{{ $t('report.entry_operator') }}</b-th>
                                  <b-th>{{ $t('report.officer_sign') }}</b-th>
                                  <b-th>{{ $t('social_service.comment') }}</b-th>
                                </b-tr>
                                <b-tr>
                                  <b-th colspan="2">{{ $n(1) }}</b-th>
                                  <b-th>{{ $n(2) }}</b-th>
                                  <b-th>{{ $n(3) }}</b-th>
                                  <b-th>{{ $n(4) }}</b-th>
                                  <b-th>{{ $n(5) }}</b-th>
                                  <b-th>{{ $n(6) }}</b-th>
                                  <b-th>{{ $n(7) }}</b-th>
                                  <b-th>{{ $n(8) }}</b-th>
                                  <b-th>{{ $n(9) }}</b-th>
                                  <b-th>{{ $n(10) }}</b-th>
                                  <b-th>{{ $n(11) }}</b-th>
                                  <b-th>{{ $n(12) }}</b-th>
                                </b-tr>
                                <span hidden>{{$total =0}}</span>
                              <b-tr v-for="(item, index) in search_report.data" :key="index">
                                <b-th>{{ $n(index + 1) }}</b-th>
                                <b-th v-if="item.donation_date || item.deposit_date">{{ (item.donation_date || item.deposit_date) | dateFormat }}</b-th>
                                <b-th>{{ currentLocale === 'en' ? $t(item.donate_by) : $t(item.donate_by_bn) }}</b-th>
                                <b-th v-if="item.deposit_slip !== '' ">{{ $n(item.deposit_slip, {useGrouping:false }) }}</b-th>
                                <b-th v-if="item.amount > 0 || item.deposit_amount > 0">{{ getDepositType(item.deposit_type) }}</b-th>
                                <b-th v-if="item.amount > 0 || item.deposit_amount > 0">{{ $n(item.amount > 0 ? item.amount : item.deposit_amount) }}</b-th>
                                <b-th v-if="item.account_no > 0 ">{{ item.deposit_date | dateFormat }} {{ $t('globalTrans.n') }} {{ $n(item.account_no, {useGrouping: false}) }}</b-th>
                                <b-th v-if="item.item_id > 0">{{ getItemName(item.item_id) }} [{{$n(item.quantity)}}] </b-th>
                                <b-th v-else></b-th>
                                <b-th>{{ $t(item.entry_operator) }}</b-th>
                                <b-th>{{ $t(item.officer_sign) }}</b-th>
                                <b-th>{{ $t(item.comment) }}</b-th>
                                <span hidden>{{ $total += item.deposit_amount + item.amount }}</span>
                              </b-tr>
                              <b-tr>
                                <b-th colspan="8"></b-th>
                                <b-th>{{$t('report.total_income')}}: </b-th>
                                <b-th>{{$n($total)}}</b-th>
                                <b-th colspan="3"></b-th>
                              </b-tr>
                              </b-table-simple>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                </b-overlay>
                </template>
              </iq-card>
            </b-col>
          </b-row>
      </b-overlay>
    </template>
  </b-container>
</template>
<script>
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { incomeRegisterReportApi } from '../../../api/routes'
// import Report from './Report'
// import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import ReportHeading from '@/Utils/report-head'
import ExportPdf from './export-pdf-details'

export default {
  mixins: [ModalBaseMasterList],
  props: ['data'],
  emits: ['load'],
  data () {
    return {
      search: {
        division_id: 0,
        district_id: 0,
        upazilla_id: 0,
        hospital_id: 0,
        month_id: 0,
        fiscal_year_id: 0
      },
      testOptionList: [],
      testList: [],
      districtList: [],
      upazillaList: [],
      testData: '',
      ndata: [],
      titleData: {
        month_name: ' '
      },
      search_report: {
        workplace_name: ' ',
        month_name: ' ',
        medicine: '0',
        different_type_test: '0',
        blood: '0',
        cloth: '0',
        wheel_chair_and_products: '0',
        milk_diet: '0',
        transportation_fair_deadbody_burial_ritual: '0',
        dialisis_therapy: '0',
        others_help: '0',
        financialy: '0',
          gender_women: '0',
          gender_man: '0',
          gender_baby: '0',
          counseling: '0',
          recreation: '0',
          social_act: '0',
          follow_up_report: '0',
          social_awarness: '0',
          socio_bene: '0',
            gender_social_women: '0',
            gender_social_man: '0',
            gender_social_baby: '0',
            rehab_report: '0',
            gender_social_rehab_women: '0',
            gender_social_rehab_man: '0',
            gender_social_rehab_baby: '0',
            tot_rehab: '0',
            benefit_pat_tot_num: '0',
            woman_third: '0',
            man_third: '0',
            baby_third: '0',
            benefit_pat_tot_nums: '0',
            benefit_pat_tot_num_disbale: '0',
            data: [],
            comment: '0'
      },
      reportHeadData: null,
      unitLoad: false,
      dataLoad: false,
      loadingPdf: false
    }
  },
  computed: {
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    yearList: function () {
      const data = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
      const years = data.map((obj, key) => {
        // const year = obj.text.split('-')[0]
        const year = obj.text
        // const year = obj.text
        return { value: obj.text_en.split('-')[1], text: year }
      })
      // Getting the last year on the end of the Fiscal Year List
      // const lastYear = (data[data.length - 1].text.split('-')[1])
      // years.push({ value: lastYear, text: lastYear })
      return years
    },
     requestTypeList: function () {
      const list = [
        { value: 1, text: this.$i18n.locale === 'en' ? 'Donation/Grant' : 'দান/অনুদান' },
        { value: 2, text: this.$i18n.locale === 'en' ? 'Zakat' : 'যাকাত' }
      ]
      return list
    },
    monthList () {
      const objectData = this.$store.state.commonObj.monthList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    formTitle () {
      return this.$t('report.income_register') + ' ' + this.$t('hospital_public_panel.report')
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    /** Used to get month name in title data */
    'search.month_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.titleData.month_name = this.getMonthName(newVal)
      }
    },
    'search.division_id': function (newVal, oldVal) {
      this.search.district_id = 0
      this.districtList = this.getDistrictList(newVal)
    },
    'search.district_id': function (newVal, oldVal) {
      this.search.upazilla_id = 0
      this.upazillaList = this.getupazillaList(newVal)
    },
    'search.upazilla_id': function (newVal, oldVal) {
      // Reset both hospital id & list
      this.search.hospital_id = 0
      if (newVal !== 0) {
        this.hospitalList = this.getHospitalListByUpazillaId(newVal)
      } else if (newVal === 0) {
        this.hospitalList = this.getHospitalListAll()
      }
    }
  },
  created () {
    if (this.data) {
      this.loadData()
    }
    this.headerName()
    this.hospitalList = this.getHospitalListAll()
    this.unitLoad = false
  },
  methods: {
    getDistrictList (divisionId = null) {
      return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === divisionId)
    },
    getupazillaList (districtId = null) {
      return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === districtId)
    },
    getHospitalListByUpazillaId: function (upazillaId = null) {
      return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.upazilla_id === upazillaId)
    },
    getHospitalListAll: function () {
      return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
    },
    getMonthName (mId = null) {
      const monthId = parseInt(mId)
      const objectData = this.monthList.find(month => month.value === monthId)
      return objectData !== undefined ? objectData.text : null
    },
    async headerName () {
      const result = await ReportHeading.getReportHead(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3)
      this.reportHeadData = result
    },
    getItemName (itemId) {
      const item = this.$store.state.HospitalDisabilityService.commonObj.hosItemList.find(service => service.value === parseInt(itemId))
      if (item !== undefined) {
        if (this.$i18n.locale === 'bn' && item.text_bn !== undefined) {
            return item.text_bn
        } else if (this.$i18n.locale === 'en' && item.text !== undefined) {
            return item.text_en
        }
      }
    },
    getDepositType (itemId) {
      const item = this.requestTypeList.find(service => parseInt(service.value) === parseInt(itemId))
      if (item !== undefined) {
        if (item.text !== undefined) {
            return item.text
        }
      }
    },
    searchData () {
        this.loadData()
    },
    // --- Load ---
    loadData () {
      this.dataLoad = true
      const params = Object.assign({}, this.data)
      RestApi.getData(hospitalServiceBaseUrl, incomeRegisterReportApi, params).then(response => {
            if (response.success) {
              this.unitLoad = true
              this.dataLoad = false
              const listObject = response
                this.testList = listObject.data
                // this.workplace_name = listObject.workplace_name
              if (this.$i18n.locale === 'bn') {
              this.workplace_name = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.find(item => item.text_en === listObject.workplace_name).text_bn
              this.month_name = this.$store.state.commonObj.monthList.find(item => item.text_en === listObject.month_name).text_bn
              this.search_report.fisYear = this.$store.state.commonObj.fiscalYearList.find(item => item.text_en === listObject.fisYear).text
              this.search_report.year = this.$store.state.commonObj.fiscalYearList.find(item => item.text_en === listObject.fisYear).text.split('-')[1]
              } else {
              this.workplace_name = listObject.workplace_name
              this.search_report.fisYear = listObject.fisYear
              this.search_report.year = listObject.fisYear.split('-')[1]
              }
                // this.$bvModal.show('modal-detail-umo').
                if (this.testList) {
                      this.search_report.data = this.testList
                      this.search_report.workplace_name = this.workplace_name
                      this.search_report.month_name = this.month_name
                      this.getItemName()
                }
              this.$emit('load', 1)
            }
      })
    },
     async pdfExport () {
            const reportTitle = this.$t('report.income_register')
            const data = JSON.parse(JSON.stringify(this.search_report))
            const titleData = { workplace_name: this.search_report.workplace_name, month_name: this.search_report.month_name }
            this.loadingPdf = true
            await ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, data, this, titleData)
            this.loadingPdf = false
    }
  }
}
</script>
<style lang="scss">
  .titleDiv {
    font-size: 18px;
  }
  .details_report {
    font-size: 8px;
    color: #000;
    h5 {
      color: green !important;
      font-size: 12px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
    .table-bordered th {
      text-align: center;
      font-size: 11px !important;
      // font-weight: 900 !important;
    }
    .table-bordered tr td {
      font-size: 9px !important;
      text-align: center;
    }
  }
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
